import { Card, Row } from '@themesberg/react-bootstrap'
import { useEffect, useState } from 'react'
import CheckoutTenantReg from '../../components/custom/TenantRegForm/TenantRegForm'
import CheckoutPage from '../../components/custom/CheckoutStep/CheckoutStep'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Steps } from 'primereact/steps'
import {
  faCreditCard,
  faInfoCircle,
  faMoneyCheckDollar,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Wrapper } from './TwoStepPage.styled'
import { setStep } from '../../store/slices/tenants'
import useRequest from '../../axios/apis/useRequest'
import MarketplaceNavBar from '../../components/Sidebar/MarketplaceNavBar/MarketplaceNavBar'
import { setLoading, setProductOwner } from '../../store/slices/main'
import SafeFormatMessage from '../../components/custom/Shared/SafeFormatMessage/SafeFormatMessage'
import {
  paymentPlatforms,
  subscriptionRegistrationSteps,
} from '../../const/const'
import PaymentMethodSelection from '../../components/custom/PaymentMethodSelection/PaymentMethodSelection'

const TwoStepProcessPage = () => {
  const hash = window.location.hash
  const array = hash.split('#')
  const orderIDHash = array.find((element) => element.includes('order-'))
  const hasPaymentMethod =
    array.find((element) => Object.keys(paymentPlatforms).includes(element)) ||
    array.find((element) => element.includes('unassigned'))

  const [orderIDParam, setOrderIDParam] = useState('')
  const dispatch = useDispatch()
  const [tenantDisplayName, setTenantDisplayName] = useState()
  const step = useSelector((state) => state.tenants.currentStep)
  console.log({ step })

  const [currentTenant, setCurrentTenant] = useState('')
  const { getProductPlanPricePublic } = useRequest()
  const { productSystemName, productOwnerSystemName, priceName } = useParams()

  useEffect(() => {
    if (!orderIDHash) {
      return
    }
    setOrderIDParam(orderIDHash.replace('order-', ''))
  }, [orderIDHash])

  useEffect(() => {
    if (!orderIDParam) {
      dispatch(setStep(subscriptionRegistrationSteps.TenantRegistration))
      return
    } else if (hasPaymentMethod) {
      dispatch(setStep(subscriptionRegistrationSteps.Checkout))
    } else {
      dispatch(setStep(subscriptionRegistrationSteps.paymentMethodSelection))
    }
    dispatch(setLoading(false))
  }, [orderIDParam, array?.length])

  let userRole = useSelector((state) => state.auth.userInfo.userType)
  if (userRole == undefined) userRole = 'notAuth'

  useEffect(() => {
    if (!productOwnerSystemName) {
      return
    }
    dispatch(setProductOwner(productOwnerSystemName))
  }, [productOwnerSystemName])

  const [hasToPay, setHasToPay] = useState()
  const [priceData, setPriceData] = useState()

  const [trialPlanId, setTrialPlanId] = useState('')
  const currency = useSelector((state) => state.main.currency)
  // useEffect(() => {
  //   dispatch(deleteAllPlanPriceBySystemName({ systemName: productSystemName }))
  //   setPriceData(null)
  // }, [currency])
  useEffect(() => {
    // if (priceData || (priceData && Object.values(priceData).length) > 0) {
    //   return
    // }
    ;(async () => {
      const price = await getProductPlanPricePublic(
        productOwnerSystemName,
        productSystemName,
        priceName
      )
      setPriceData(price.data.data)
      price.data.data && setTrialPlanId(price.data.data?.product.trialPlanId)
    })()
  }, [productSystemName, priceName, currency])
  return (
    <Wrapper>
      <MarketplaceNavBar />

      <div className="main-container ">
        <Steps
          model={[
            {
              label: (
                <>
                  <FontAwesomeIcon icon={faInfoCircle} />{' '}
                  <SafeFormatMessage id="Subscribtion-Info" />
                </>
              ),
            },
            {
              label: (
                <>
                  <FontAwesomeIcon icon={faCreditCard} />{' '}
                  <SafeFormatMessage id="Payment-Method" />
                </>
              ),
            },
            {
              label: (
                <>
                  <FontAwesomeIcon icon={faMoneyCheckDollar} />{' '}
                  <SafeFormatMessage id="Check-Out" />
                </>
              ),
            },
          ]}
          activeIndex={step - 1}
          readOnly={step != 1 ? false : true}
        />
        {/* {userRole != 'notAuth' && (
          <BreadcrumbComponent breadcrumbInfo={'ProductList'} />
        )}{' '} */}
        <Row>
          {step === subscriptionRegistrationSteps.TenantRegistration && (
            <CheckoutTenantReg
              type="create"
              popupLabel={<SafeFormatMessage id="Enter-Your-Info" />}
              setCurrentTenant={setCurrentTenant}
              setHasToPay={setHasToPay}
              setDisplayName={setTenantDisplayName}
              priceData={priceData}
              setPriceData={setPriceData}
            />
          )}
          {step === subscriptionRegistrationSteps.paymentMethodSelection && (
            <PaymentMethodSelection priceData={priceData} />
          )}
          {step === subscriptionRegistrationSteps.Checkout && (
            <CheckoutPage
              currentTenant={currentTenant}
              hasToPay={hasToPay}
              setHasToPay={setHasToPay}
              tenantDisplayName={tenantDisplayName}
              priceData={priceData}
              setPriceData={setPriceData}
              trialPlanId={trialPlanId}
            />
          )}{' '}
        </Row>
      </div>
    </Wrapper>
  )
}

export default TwoStepProcessPage
